import { BiteLogHelper, ModelType } from '@biteinc/enums';
import { StringHelper, Time } from '@biteinc/helpers';

import { TimeHelper } from '../helpers/time_helper';

app.BiteLog = app.AbstractModel.extend({
  ModelName: 'biteLog',
  Schema: {
    displayName: 'system log',
  },
  Type: ModelType.BiteLog,

  matchesQuery(query /* optDisplayName */) {
    if (!query) {
      return true;
    }

    const lcQuery = query;

    const descriptionMatchesQuery =
      StringHelper.normalizeQuery(this.get('description')).indexOf(lcQuery) !== -1;
    if (descriptionMatchesQuery) {
      return true;
    }

    const humanReadableTypeMatchesQuery =
      StringHelper.normalizeQuery(this.get('humanReadableType')).indexOf(lcQuery) !== -1;
    if (humanReadableTypeMatchesQuery) {
      return true;
    }

    const humanReadableStatusMatchesQuery =
      StringHelper.normalizeQuery(this.get('humanReadableStatus')).indexOf(lcQuery) !== -1;
    if (humanReadableStatusMatchesQuery) {
      return true;
    }

    return app.AbstractModel.prototype.matchesQuery.apply(this, arguments);
  },

  isSimilar(other) {
    return (
      this.get('clientName') === other.get('clientName') &&
      this.get('type') === other.get('type') &&
      this.get('status') === other.get('status') &&
      !this.get('isFinalError')
    );
  },

  isKioskOk() {
    return BiteLogHelper.getSeverity(this.get('type'), this.get('status')) === 'recovery';
  },

  isError() {
    if (this.get('isFinalError')) {
      return true;
    }

    return BiteLogHelper.getSeverity(this.get('type'), this.get('status')) === 'error';
  },

  isWarning() {
    return BiteLogHelper.getSeverity(this.get('type'), this.get('status')) === 'warning';
  },

  displayNameHtml() {
    return this.get('description').split('\n').join('<br />');
  },

  /**
   * @description This crazy url builder is taken from this thread, where they are saying this will
   * be deprecated in the future: https://support.newrelic.com/s/hubtopic/aAX8W0000008d1BWAQ/link-to-logs-from-outside-new-relic
   */
  getNewRelicUrl() {
    const begin = this.get('createdAt') - 5 * Time.MINUTE;
    const end = this.get('createdAt') + 5 * Time.MINUTE;
    const account = 6285639;
    const launcher = btoa(
      JSON.stringify({
        isEntitled: true,
        query: this.get('kioskId'),
        environment: 'us-production',
        eventTypes: ['Log'],
      }),
    );
    const pane = btoa(JSON.stringify({ nerdletId: 'logger.log-tailer', accountId: account }));

    return `https://one.newrelic.com/launcher/logger.log-launcher?platform[accountId]=${account}&begin=${begin}&end=${end}&pane=${pane}&launcher=${launcher}&platform[timeRange][begin_time]=${begin}&platform[timeRange][end_time]=${end}`;
  },

  getPostHogKioskUrl() {
    const query = {
      kind: 'DataTableNode',
      full: true,
      source: {
        kind: 'EventsQuery',
        select: [
          '*',
          'event',
          'person',
          'coalesce(properties.$current_url, properties.$screen_name) -- Url / Screen',
          'properties.$lib',
          'timestamp',
        ],
        orderBy: ['timestamp DESC'],
        after: Time.moment(this.get('createdAt'), 'utc').subtract(5, 'minutes').toISOString(),
        before: Time.moment(this.get('createdAt'), 'utc').add(5, 'minutes').toISOString(),
        properties: [
          {
            key: 'kioskId',
            value: [this.get('kioskId')],
            operator: 'exact',
            type: 'event',
          },
        ],
      },
      propertiesViaUrl: true,
      showSavedQueries: true,
      showPersistentColumnConfigurator: true,
    };
    const encodedQuery = encodeURIComponent(JSON.stringify(query));
    return `https://us.posthog.com/project/86352/activity/explore#q=${encodedQuery}`;
  },

  getPostHogOrderUrl() {
    const query = {
      kind: 'DataTableNode',
      full: true,
      source: {
        kind: 'EventsQuery',
        select: [
          '*',
          'event',
          'person',
          'coalesce(properties.$current_url, properties.$screen_name) -- Url / Screen',
          'properties.$lib',
          'timestamp',
        ],
        orderBy: ['timestamp DESC'],
        properties: [
          {
            key: 'orderId',
            value: [this.get('orderId')],
            operator: 'exact',
            type: 'event',
          },
        ],
      },
      propertiesViaUrl: true,
      showSavedQueries: true,
      showPersistentColumnConfigurator: true,
    };
    const encodedQuery = encodeURIComponent(JSON.stringify(query));
    return `https://us.posthog.com/project/86352/activity/explore#q=${encodedQuery}`;
  },

  toCsv() {
    return [
      TimeHelper.displayDateFromTimestamp(
        this.get('createdAt'),
        app.site?.get('timezone') ?? Time.BITE_TZ,
      ),
      this.get('humanReadableType'),
      this.get('humanReadableStatus'),
      this.get('clientName'),
      this.get('orderId'),
    ];
  },
});
